import { ReactNode, useEffect } from "react";

import { useRouter } from "next/router";

import { Spin } from "antd";
import nProgress from "nprogress";

function PageLoading({ pageLoading, children }: { pageLoading?: boolean; children: ReactNode }) {
  const router = useRouter();

  useEffect(() => {
    const handleStart = (url: string, opt: any) => {
      if (opt.shallow) {
        return;
      }

      if (!url.includes("search")) {
        nProgress.start();
      }
    };

    const handleComplete = () => {
      nProgress.done();
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, []);

  return <Spin spinning={pageLoading}>{children}</Spin>;
}

export default PageLoading;
